import {
  CHAT_ASSIGNED,
  CONTINUE_CHAT,
  OPERATOR_SEND_MESSAGE,
  OPERATOR_SEND_TRANSLATE_MESSAGE,
  SEND_INITIAL_MESSAGES_TO_CLIENT,
  VISITOR_SEND_MESSAGE
} from '../app-communication/actions/from-cluster';

import {
  SEND_CHAT_MESSAGE_FAILED,
  SEND_CHAT_MESSAGE_SUCCEEDED,
  SEND_CHAT_MESSAGE_PENDING
} from '../app-communication/actions/from-client-frontend';

import { CLEAR_STORE, CREATE_SYSTEM_MESSAGE } from '../constants';

import {
  createMessageAttempt,
  createMessage,
  createOperatorMessage,
  createTranslatedSystemMessage
} from './utils/messages';
import { MESSAGE_TYPES } from '../../../src/shared/constants';

/**
 * @typedef {Array<*>} MessagesReducer - TODO
 * @property { boolean } operatorIsTyping
 */
export const initialState = [];

export const messageActionLogReducer = (state = [], action) => {
  switch (action.type) {
    case CONTINUE_CHAT:
    case SEND_INITIAL_MESSAGES_TO_CLIENT:
    case SEND_CHAT_MESSAGE_PENDING:
    case SEND_CHAT_MESSAGE_SUCCEEDED:
    case SEND_CHAT_MESSAGE_FAILED:
    case VISITOR_SEND_MESSAGE:
    case OPERATOR_SEND_TRANSLATE_MESSAGE:
    case OPERATOR_SEND_MESSAGE:
    case CREATE_SYSTEM_MESSAGE:
    case CLEAR_STORE:
    case CHAT_ASSIGNED:
      return [...state, action.type];
    default:
      return state;
  }
};

export const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTINUE_CHAT:
    case SEND_INITIAL_MESSAGES_TO_CLIENT:
      const messages = action.payload.messages || [];
      return [...messages.map((msgPayload) => createMessage(msgPayload))];

    case SEND_CHAT_MESSAGE_PENDING:
      return state.concat(
        createMessageAttempt({
          message: action.payload.message,
          fe_ts: action.payload.fe_ts
        })
      );
    case SEND_CHAT_MESSAGE_SUCCEEDED:
      return state.map((message) =>
        message.fe_ts === action.payload.fe_ts
          ? {
              ...message,
              id: action.payload.id,
              messageStatus: 'confirmed'
            }
          : message
      );
    case SEND_CHAT_MESSAGE_FAILED:
      return state.map((message) =>
        message.fe_ts === action.payload.fe_ts
          ? {
              ...message,
              messageStatus: 'unconfirmed'
            }
          : message
      );
    case VISITOR_SEND_MESSAGE:
      const lastMessageIndex = state.length - 1;
      const newState = state.reduce(
        ({ foundMessageToConfirm, messages }, storedMessage, idx) => {
          const shouldConfirmMessage = Boolean(
            storedMessage.messageType === MESSAGE_TYPES.FROM_USER && storedMessage.fe_ts === action.payload.fe_ts
          );

          // if user sent multiple messages with same content
          // when we receive a confirmation, we confirm the first one only
          // there should be an event(s) for the other(s) as well
          if (shouldConfirmMessage && !foundMessageToConfirm) {
            return {
              foundMessageToConfirm: true,
              messages: [...messages, createMessage(action.payload)]
            };
          }

          // just a normal iteration, nothing found to update
          if (lastMessageIndex === idx && !foundMessageToConfirm) {
            return {
              foundMessageToConfirm,
              messages: [...messages, storedMessage, createMessage(action.payload)]
            };
          }

          // if we iterated all messages, but didnt find one to confirm
          // it is probably a case with message sent from another tab
          // attaching it to the list of messages
          return {
            foundMessageToConfirm,
            messages: [...messages, storedMessage]
          };
        },
        { foundMessageToConfirm: false, messages: [] }
      );

      return newState.messages;
    case OPERATOR_SEND_TRANSLATE_MESSAGE:
    case OPERATOR_SEND_MESSAGE:
      const messageId = action.payload.line_id;
      const message = state.find((msg) => msg.id === messageId);

      if (message) {
        const newMessage = {
          ...message,
          ...createOperatorMessage(action.payload)
        };

        return state.map((msg) => (msg.id === action.payload.line_id ? newMessage : msg));
      }

      return state.concat(createOperatorMessage(action.payload));

    case CREATE_SYSTEM_MESSAGE:
      return state.concat(
        createTranslatedSystemMessage({
          intlKey: action.payload.intlKey,
          intlValues: action.payload.intlValues,
          timestamp: action.payload.timestamp,
          type: action.payload.type
        })
      );

    case CLEAR_STORE:
    case CHAT_ASSIGNED:
      return initialState;
    default:
      return state;
  }
};
